import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  gridItem: {
    marginTop: '1rem',
    position: 'relative',
    padding: 0,
  },
  reviews: {
    padding: '0.5rem',
    margin: '-1rem 0 0rem',
  },
  divider: {
    marginTop: '0.5rem',
  },
}));
